import { useState } from 'react';
import { HelpAssistant } from '../components/HelpAssistant.jsx';
import { PasswordInput } from '../components/PasswordInput.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import { Navigate, useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { login, auth, loading, error } = useAuth();
  const nav = useNavigate();
  const [email,setEmail] = useState('');
  const [senha,setSenha] = useState('');
  if (auth) return <Navigate to="/" replace />;

  const submit = async e => {
    e.preventDefault();
    try { await login(email, senha); nav('/'); } catch (_) {}
  };

  return (
    <div className="login-page">
      <header className="login-header">
        <div className="titles">
          <span className="app-title">Reciclagem Capital</span>
          <span className="app-subtitle">Sistema de Bônus e Métricas</span>
        </div>
      </header>
      <div className="login-body">
        <form onSubmit={submit} className="card login-card">
          <h2 className="login-heading">Acesso</h2>
          <div className="field">
            <label>Email</label>
            <input type="email" value={email} onChange={e=>setEmail(e.target.value)} required />
          </div>
            <div className="field">
              <PasswordInput label="Senha" value={senha} onChange={e=>setSenha(e.target.value)} required />
            </div>
          {error && <div className="error" role="alert">{error}</div>}
          <button className="btn mt-md login-submit" disabled={loading}>{loading ? 'Entrando...' : 'Entrar'}</button>
          <p className="muted login-footnote">Sistema de Métricas & Bonificação</p>
        </form>
      </div>
      <footer className="site-footer login-footer">
        <span>Reciclagem Capital © Todos os direitos reservados.</span>
      </footer>
        <HelpAssistant />
    </div>
  );
}
